<script>
import {notificationMethods, productMethods} from "@/state/helpers";

import {required} from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Ürünler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      items: [],
      product: [],
      products: [],
      title: "Ürünler",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Ürünler",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,

      addForm: {
        name: "",
        code: "",
        content: "",
        section: "book",
      },
      editForm: {
        name: "",
        code: "",
        content: "",
        section: "",
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      search: '',
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          label: "Stok Adı",
          sortable: true,
        },
        {
          key: "code",
          label: "Stok Kodu",
          sortable: false,
        },
        {
          key: "content",
          label: "Ürün Açıklaması",
          sortable: false,
        },
        {
          key: "balance",
          label: "Stok Durumu",
          sortable: false,
        },
        {
          key: "createdAt",
          label: "Oluşturulma Tarihi",
          sortable: true,
        },
        {
          key: "detail",
          label: "Detay",
        },
        {
          key: "edit",
          label: "edit",
        },
        {
          key: "delete",
          label: "delete",
        },
      ],
      pageInput:1
    };
  },
  validations: {
    addForm: {
      name: {required},
      code: {required},
      section: {required},
    },
    editForm: {
      name: {required},
      code: {required},
      section: {required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
  },
  watch: {
    page(newPage) {
      this.pageInput=newPage;
      this.getProducts(newPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getProducts();
        } else {
          this.page = 1;
        }
      }
    }
  },
  mounted() {
    this.getProducts();
  },
  methods: {
    ...productMethods,
    ...notificationMethods,
    doSearch() {
      if (this.page === 1) {
        this.getProducts();
      } else {
        this.page = 1;
      }
    },
    resetForm() {
      this.addForm = {
        name: "",
        code: "",
        content: "",
        section: "book",
      };
      this.editForm = {
        name: "",
        code: "",
        content: "",
        section: "",
      };
      this.addSubmitted = false,
          this.editSubmitted = false;
    },

    getProducts(page = this.page) {
      this.itemsLoaded = false;
      this.fetchProducts({page, limit: this.perPage, search: this.search}).then(res => {
        this.totalRows = res.total;
        // getting category ready for fields
        this.items = res.docs.map(elem => {
          return elem;
        })
        this.itemsLoaded = true;
      })
    },

    handleSubmit() {
      this.addSubmitted = true;
      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid
      ) {
        return;
      } else {
        this.createProduct(this.addForm).then(() => {
          this.toastMessage = "Ürün başarıyla eklendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.showModal = false;
          this.getProducts();
          this.addForm.name = "";
          this.addForm.code = "";
          this.addForm.content = "";
          this.addForm.section = "book";
        })
      }
    },

    handleEditSubmit() {
      this.editSubmitted = true;
      this.$v.editForm.$touch();
      if (
          this.$v.editForm.$invalid
      ) {
        return;
      } else {

        this.updateProduct({id: this.editId, data: this.editForm}).then(() => {
          this.toastMessage = "Ürün başarıyla düzenlendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.editModal = false;
          this.getProducts();
        })
      }
    },
    handleDeleteSubmit() {

      this.deleteProduct(this.deleteId).then(() => {
        this.deleteModal = false;
        this.toastMessage = "Ürün başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getProducts();
      })

    },

    openEdit(product) {
      this.editForm.name = product.name;
      this.editForm.code = product.code;
      this.editForm.content = product.content;
      this.editForm.section = product.section;
      this.editId = product.id;
      this.editModal = true;
    },
    openDelete(product) {
      this.deleteId = product.id;
      this.deleteModal = true;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row" v-if="itemsLoaded ">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true; resetForm();"
                >
                  Ürün Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="items"
                  :fields="fields"
                  responsive="sm"
              >
                <template v-slot:cell(createdAt)="data">
                  {{ data.item.createdAt| formatDate }}
                </template>
                <template v-slot:cell(balance)="data">
                  <p v-if="Number(data.item.balance)<100" :style="{color:'red',fontWeight:'bold'}">
                    {{ data.item.balance }}
                  </p>
                  <p v-else>{{ data.item.balance }}</p>
                </template>
                <template v-slot:cell(edit)="data">
                  <button
                      class="btn btn-warning d-flex py-2"
                      @click="openEdit(data.item)"
                  >
                    <i :class="`bx bxs-edit bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(detail)="data">
                  <button
                      class="btn btn-info d-flex py-2"
                      @click="$router.push({name:'productDetail',params:{productId: data.item.id}})"
                  >
                    <i :class="`bx bxs-detail bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(delete)="data">
                  <button
                      class="btn btn-danger d-flex py-2"
                      @click="openDelete(data.item)"
                  >
                    <i :class="`bx bx-trash bx-xs`"></i>
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <input
                        :style="{width:'40px', maxWidth:'100%', display:'flex',justifyContent:'center', marginTop:'-3px'}"
                        @keyup.enter="page=pageInput" v-model="pageInput" type="text" class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal v-model="showModal" title="Ürün Ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Ürün Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Ürün Adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="code">Ürün Kodu</label>
                <input
                    id="code"
                    type="text"
                    v-model="addForm.code"
                    class="form-control"
                    placeholder="Ürün Kodu Giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.code.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.code.required"
                    class="invalid-feedback"
                >
                  Ürün Kodu girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="content">Açıklama</label>
                <textarea
                    name="content"
                    id="content"
                    type="text"
                    autocomplete="off"
                    v-model="addForm.content"
                    class="form-control"
                    placeholder="Açıklama giriniz"
                />
              </div>
            </div>

            <div class="col-12">
              <div class="mb-3">
                <label for="section">Tipi</label>
                <select name="section"
                        id="section"
                        v-model="addForm.section"
                        class="form-control">
                  <option value="book">Kitap</option>
                  <option value="e-book">E-Kitap</option>
                  <option value="language">Dil</option>
                </select>
              </div>
            </div>

          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm();"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Ürün Ekle
            </b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal v-model="editModal" title="Ürün Düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Ürün Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="Ürün Adı giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Ürün Adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="code">Ürün Kodu</label>
                <input
                    id="code"
                    type="text"
                    v-model="editForm.code"
                    class="form-control"
                    placeholder="Ürün Kodu giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.code.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.code.required"
                    class="invalid-feedback"
                >
                  Ürün Kodu gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="content">Açıklama</label>
                <textarea
                    name="content"
                    id="content"
                    type="text"
                    autocomplete="off"
                    v-model="editForm.content"
                    class="form-control"
                    placeholder="Açıklama giriniz"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="section">Tipi</label>
                <select name="section"
                        id="section"
                        v-model="editForm.section"
                        class="form-control">
                  <option value="book">Kitap</option>
                  <option value="e-book">E-Kitap</option>
                  <option value="language">Dil</option>
                </select>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Ürünü Düzenle
            </b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu ürünü silmek istediğinize emin misiniz? Silinmiş ürünler geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>

    </div>
    <div class="spinner-wrapper" v-else>
      <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
